<script setup>
import {computed} from 'vue'
import {
  Ban,
  Bell,
  BookOpen,
  BrickWall,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  ClipboardClock,
  Clock,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleUserRound,
  CircleX,
  Cog,
  Diamond,
  Frown,
  Gauge,
  HandCoins,
  Heart,
  House,
  IdCardLanyard,
  Inbox,
  Info,
  LogOut,
  Moon,
  MoveLeft,
  MoveRight,
  OctagonAlert,
  Plus,
  Printer,
  RefreshCw,
  Shield,
  Sun,
  SquarePen,
  Timer,
  Trash2,
  TrendingUpDown,
  TriangleAlert,
  Webcam,
  X
} from 'lucide-vue-next'

const icons = {
  Ban,
  Bell,
  BookOpen,
  BrickWall,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  ClipboardClock,
  Clock,
  CircleAlert,
  CircleCheck,
  CircleDashed,
  CircleUserRound,
  CircleX,
  Cog,
  Diamond,
  Frown,
  Gauge,
  HandCoins,
  Heart,
  House,
  IdCardLanyard,
  Inbox,
  Info,
  LogOut,
  Moon,
  MoveLeft,
  MoveRight,
  OctagonAlert,
  Plus,
  Printer,
  RefreshCw,
  Shield,
  Sun,
  SquarePen,
  Timer,
  Trash2,
  TrendingUpDown,
  TriangleAlert,
  Webcam,
  X
}

const props = defineProps({
  name: {type: String, required: true},
  size: {type: [Number, String], default: 20},
  color: {type: String, default: 'currentColor'},
  class: {type: [String, Array, Object], default: ''} // ✅ allow Tailwind classes
})

const Icon = computed(() => icons[props.name] || null)
</script>

<template>
  <component
      v-if="Icon"
      :is="Icon"
      :size="size"
      :color="color"
      :class="['align-middle', props.class]"
  />
</template>
